<ng-container *dialog-title>
  <h3>Pop-up löschen</h3>
</ng-container>

<ng-container *dialog-content>
  <p>
    Möchten Sie das Pop-up <strong>"{{ itemToDelete$$()?.title }}"</strong> wirklich löschen?
  </p>
  <p>Diese Aktion kann nicht rückgängig gemacht werden.</p>
</ng-container>

<ng-container *dialog-actions>
  <jf-button
    variant="primary"
    text="Löschen"
    (click)="doConfirm()"
  ></jf-button>
  <jf-button
    variant="ghost"
    text="Abbrechen"
    (click)="doCancel()"
  ></jf-button>
</ng-container>
